const positions = {
  'ZAR': 'before',
  'USD': 'before',
  'GBP': 'before',
  'THB': 'before',
  'EUR': 'after',
};

module.exports = function currencyPosition(code) {
  if (!code) return 'before';

  return positions[code] || 'before';
};
